import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { podcastInfo } from '../data/mockData';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Episodes', href: '#episodes' },
    { name: 'About', href: '#about' },
    { name: 'Subscribe', href: '#subscribe' }
  ];

  return (
    <header data-testid="main-header"
      className="fixed top-0 left-0 right-0 z-50 bg-black shadow-[0_4px_30px_rgba(147,51,234,0.3)] border-b border-purple-800/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo — NO[Naketa]APOLOG[Mic] zero gaps, mic round next to G */}
          <a href="#home" className="flex items-center group overflow-hidden" data-testid="header-logo" style={{ gap: '0px' }}>
            <span className="hero-title-text-sm leading-none"
              style={{ fontSize: '20px', position: 'relative', zIndex: 1 }}>
              NO
            </span>
            <img src="https://customer-assets.emergentagent.com/job_reggae-naketa-show/artifacts/37iaoi6w_keta1%20copy.png"
              alt="!" className="h-12 w-auto relative z-10" style={{ marginLeft: '-8px', marginRight: '-10px' }} />
            <span className="hero-title-text-sm leading-none"
              style={{ fontSize: '20px', position: 'relative', zIndex: 1 }}>
              APOLOG
            </span>
            <img src={podcastInfo.branding.logoMic} alt="I"
              className="mic-pulsate rounded-full object-contain"
              style={{ height: '40px', width: '40px', marginLeft: '-14px', filter: 'drop-shadow(0 0 4px rgba(168, 85, 247, 0.5))', mixBlendMode: 'lighten', WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%), linear-gradient(to bottom, transparent 0%, black 5%, black 95%, transparent 100%)', WebkitMaskComposite: 'destination-in', maskImage: 'linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%), linear-gradient(to bottom, transparent 0%, black 5%, black 95%, transparent 100%)', maskComposite: 'intersect' }} />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a key={link.name} href={link.href}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
                className="text-gray-300 hover:text-purple-400 transition-colors duration-300 font-bold relative group"
                style={{ fontFamily: "'Prata', serif", fontSize: '13px', letterSpacing: '1px' }}>
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-400 to-purple-600 group-hover:w-full transition-all duration-300" />
              </a>
            ))}
            <Button data-testid="header-listen-btn"
              className="bg-gradient-to-r from-purple-800 to-purple-700 hover:from-purple-700 hover:to-purple-600 text-white font-bold text-xs transition-all duration-300 shadow-lg shadow-purple-700/30 hover:scale-105 border border-purple-500/30"
              style={{ fontFamily: "'Prata', serif", letterSpacing: '1px' }}
              onClick={() => window.location.href = '#subscribe'}>
              Listen Now
            </Button>
          </nav>

          {/* Mobile Menu */}
          <button data-testid="mobile-menu-btn"
            className="md:hidden text-gray-300 hover:text-purple-400 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden py-4 space-y-4 bg-black/95 backdrop-blur-md rounded-lg mt-2 border border-purple-600/20" data-testid="mobile-nav">
            {navLinks.map((link) => (
              <a key={link.name} href={link.href}
                className="block px-4 py-2 text-gray-300 hover:text-purple-400 hover:bg-purple-500/10 transition-all duration-300 rounded"
                style={{ fontFamily: "'Prata', serif" }}
                onClick={() => setIsMobileMenuOpen(false)}>
                {link.name}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
